// download.js

const filenameFromContentDisposition = (header, fallback) => {
  if (!header) return fallback;
  const utfMatch = /filename\*=UTF-8''([^;]+)/i.exec(header);
  if (utfMatch?.[1]) {
    try {
      return decodeURIComponent(utfMatch[1].trim().replace(/['"]/g, ''));
    } catch {
      return utfMatch[1].trim().replace(/['"]/g, '');
    }
  }
  const match = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i.exec(header);
  if (match?.[1]) return match[1].replace(/['"]/g, '').trim();
  return fallback;
};

const triggerBlobDownload = (blob, filename) => {
  const downloadUrl = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = downloadUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(downloadUrl);
  document.body.removeChild(a);
};

export const fetchFileBlobFromApi = async ({ url, token, filename }) => {
  const response = await fetch(url, {
    method: 'GET',
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error(`Server returned ${response.status} during file download`);
  }

  const blob = await response.blob();
  const resolvedName = filenameFromContentDisposition(
    response.headers.get('Content-Disposition'),
    filename,
  );
  return { blob, filename: resolvedName };
};

export const downloadFileFromApi = async ({
  url,
  token,
  filename,
  onError,
}) => {
  try {
    const { blob, filename: resolvedName } = await fetchFileBlobFromApi({
      url,
      token,
      filename,
    });
    triggerBlobDownload(blob, resolvedName);
  } catch (error) {
    console.error('Download error:', error);
    if (onError) onError(error);
    throw error;
  }
};

export const downloadBlobsAsZip = async (files, zipFilename = 'download') => {
  const { default: JSZip } = await import('jszip');
  const zip = new JSZip();
  const duplicateTracker = {};

  files.forEach(({ blob, filename }) => {
    const raw = (filename || 'file').replace(/[\/\\:*?"<>|]/g, '');
    const dot = raw.lastIndexOf('.');
    const stem = dot > 0 ? raw.slice(0, dot) : raw;
    const ext = dot > 0 ? raw.slice(dot) : '';
    const count = duplicateTracker[raw] ?? 0;
    duplicateTracker[raw] = count + 1;
    zip.file(count === 0 ? raw : `${stem}_${count}${ext}`, blob);
  });

  const zipBlob = await zip.generateAsync({ type: 'blob' });
  const sanitizedZipFilename = (zipFilename || 'download')
    .replace(/[\/\\:*?"<>|]/g, '')
    .split(' ')
    .join('_');
  triggerBlobDownload(zipBlob, `${sanitizedZipFilename}.zip`);
};
